module.exports = __webpack_public_path__ + "static/media/back1.5a7d3449.png";